// @app/core/config/app-registry.ts
import { LoadChildrenCallback } from '@angular/router';
import { TenantKey } from '@app/core/enums/tenant-key.enum';

export interface AppConfig {
  path: TenantKey; // e.g., 'probate', 'guardianship'
  loadChildren: LoadChildrenCallback;
  data?: Record<string, unknown>;
}

export const TENANT_ROUTES_CONFIG: AppConfig[] = [
  {
    path: TenantKey.PROBATE,
    loadChildren: () =>
      import('@app/probate/probate.routes').then(
        (m) => m.probateDashboardRoutes,
      ),
    data: { title: 'Probate Application', tenantType: TenantKey.PROBATE },
  },
  {
    path: TenantKey.GUARDIANSHIP,
    loadChildren: () => import('@app/guardianship/guardianship.routes'),
    data: {
      title: 'Guardianship Application',
      tenantType: TenantKey.GUARDIANSHIP,
    },
  },
  {
    path: TenantKey.MINOR,
    loadChildren: () => import('@app/minor-estates/minor-estates.routes'),
    data: {
      title: 'Minor Estates Application',
      tenantType: TenantKey.MINOR,
    },
  },
  {
    path: TenantKey.TRUST,
    loadChildren: () => import('@app/trust/trust.routes'),
    data: {
      title: 'Trust Application',
      tenantType: TenantKey.TRUST,
    },
  },
];
